import { render, staticRenderFns } from "./BasePriceStatus.vue?vue&type=template&id=53c7502c&scoped=true"
import script from "./BasePriceStatus.vue?vue&type=script&lang=ts"
export * from "./BasePriceStatus.vue?vue&type=script&lang=ts"
import style0 from "./BasePriceStatus.vue?vue&type=style&index=0&id=53c7502c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c7502c",
  null
  
)

export default component.exports